import { getLeafValue } from "../../helper";
import { MeasureSeriesSortingType, ReferenceDateDimension } from "../../types";
import { DatapointValueTypeEnum, DatapointValueVariationTypeEnum } from "api/ux/src";
import { getDateWhenString } from "common/date-utils";
import { esgComparator } from "common/esg-helpers";
const sortString = (sortingType, dpa, dpb) => {
    const stringA = getLeafValue(dpa?.value)?.toString() || "";
    const stringB = getLeafValue(dpb?.value)?.toString() || "";
    switch (sortingType) {
        case MeasureSeriesSortingType.Esg: return esgComparator(stringA, stringB);
        case MeasureSeriesSortingType.Desc: return stringB.localeCompare(stringA);
        case MeasureSeriesSortingType.Asc:
        default: return stringA.localeCompare(stringB);
    }
};
const sortDate = (sortingType, dpa, dpb) => {
    const dateA = getLeafValue(dpa?.value)?.getTime() || 0;
    const dateB = getLeafValue(dpb?.value)?.getTime() || 0;
    return sortingType === MeasureSeriesSortingType.Desc
        ? dateB - dateA
        : dateA - dateB;
};
const sortNumber = (sortingType, dpa, dpb) => {
    const numberA = getLeafValue(dpa?.value) || 0;
    const numberB = getLeafValue(dpb?.value) || 0;
    if (numberA === numberB) {
        return 0;
    }
    if (numberA < numberB) {
        return sortingType === MeasureSeriesSortingType.Asc ? -1 : 1;
    }
    return sortingType === MeasureSeriesSortingType.Asc ? 1 : -1;
};
const sortVariation = (sortingType, dpa, dpb) => {
    const vdpa = dpa?.value;
    const vdpb = dpb?.value;
    if (dpa?.variationType) {
        switch (dpa?.variationType) {
            case DatapointValueVariationTypeEnum.Number:
            case DatapointValueVariationTypeEnum.Bool:
            case DatapointValueVariationTypeEnum.Money:
                return sortNumber(sortingType, vdpa.current, vdpb.current);
            case DatapointValueVariationTypeEnum.String:
                return sortString(sortingType, { type: DatapointValueTypeEnum.String, value: vdpa.current }, { type: DatapointValueTypeEnum.String, value: vdpb.current });
            case DatapointValueVariationTypeEnum.Date:
                return sortDate(sortingType, { type: DatapointValueTypeEnum.Date, value: vdpa.current }, { type: DatapointValueTypeEnum.Date, value: vdpb.current });
            default: throw new Error("Invalid variationType");
        }
    }
    throw new Error("variationType is null");
};
export const sortByDatapoint = (field, sortingType) => {
    if (field === ReferenceDateDimension) {
        return (args, a, b) => {
            const dateA = getDateWhenString(a.date)?.getTime() || 0;
            const dateB = getDateWhenString(b.date)?.getTime() || 0;
            return sortingType === MeasureSeriesSortingType.Desc
                ? dateB - dateA
                : dateA - dateB;
        };
    }
    return (args, a, b) => {
        const dpa = a.datapoints?.filter((d) => d.name === field)?.[0];
        const dpb = b.datapoints?.filter((d) => d.name === field)?.[0];
        let dpaType = dpa?.type || DatapointValueTypeEnum.String;
        const dpbType = dpb?.type || DatapointValueTypeEnum.String;
        if (dpaType !== dpbType) {
            // If non consistent, handle both as strings
            dpaType = DatapointValueTypeEnum.String;
        }
        switch (dpaType) {
            case DatapointValueTypeEnum.String: return sortString(sortingType, dpa, dpb);
            case DatapointValueTypeEnum.Bool:
            case DatapointValueTypeEnum.Number:
            case DatapointValueTypeEnum.Money: return sortNumber(sortingType, dpa, dpb);
            case DatapointValueTypeEnum.Area: return sortNumber(sortingType, dpa, dpb);
            case DatapointValueTypeEnum.Unit: return sortNumber(sortingType, dpa, dpb);
            case DatapointValueTypeEnum.Date: return sortDate(sortingType, dpa, dpb);
            case DatapointValueTypeEnum.Variation: return sortVariation(sortingType, dpa, dpb);
            default: throw new Error(`${dpaType} datapoint type not supported. object value was ${JSON.stringify(dpa)}`);
        }
    };
};
